import { useInstantSearch } from "react-instantsearch-hooks-web";
import styles from "./Stats.module.scss";

/**
 * Display product count from Algolia search.
 * @param {string} [indexName] - Optional index to scope to. If not provided, uses the closest scoped result.
 */

export default function Stats({ indexName }) {
  const { scopedResults } = useInstantSearch();

  const resultsToRender = indexName
    ? scopedResults.filter(({ indexId }) => indexId === indexName)
    : scopedResults.slice(0, 1); // fallback to nearest index 

  return (
    <>
      {resultsToRender.map(({ indexId, results }) => (
        <span key={indexId} className={styles.productCount}>
          {results.nbHits === 0
            ? "0 Products"
            : `${results.nbHits} ${results.nbHits === 1 ? "Product" : "Products"}`}
        </span>
      ))}
    </>
  );
}
